import { Divider } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomDivider = styled(Divider)`
    border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
`;
